import type { TFunction } from 'i18next';

/**
 * Ошибки сохранения профиля / текстов CV → польский текст из локали.
 *
 * ⚠️ Здесь различает ПОЛЕ, а не код. На бэкенде
 * (`tmsis/career/services/profile.py`) все три проверки поднимают один и тот же
 * `ERROR_INVALID` — код `'invalid'`, — а отличаются они значением `field`:
 * `photo`, `skills`, `language`. Маппер только по коду свёл бы три разных
 * причины в одну фразу «неверные данные», и студент не понял бы, что именно
 * не так с его фотографией.
 *
 * Раньше оба тоста (`/resume` и блок текстов CV) показывали серверный
 * `message` НАПРЯМУЮ и запасного перевода не имели вовсе — то есть русский
 * текст был единственным, что видел польский пользователь.
 */
export const getCareerProfileErrorText = (
  t: TFunction,
  code?: string | null,
  field?: string | null,
): string => {
  switch (field) {
    case 'photo':
      return t('careerProfile.errors.photo');
    case 'skills':
      return t('careerProfile.errors.skills');
    case 'language':
      return t('careerProfile.errors.language');
    default:
      break;
  }
  if (code === 'not_found') {
    return t('careerProfile.errors.notFound');
  }
  return t('careerProfile.errors.generic');
};
